<script lang="ts">
  import type { SalesRep } from "@shared/types/SalesRep";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import PhoneInput from "@shared/svelte/Components/PhoneInput.svelte";
  export let removeSalesRep;
  export let salesRep: SalesRep;

</script>

{#if salesRep}
  <div
    class="fizz-flex-row-12 fizz-align-content-start fizz-bordered fizz-inset-square-16 fizz-text-medium"
  >
    <Icon type="Contact" height="16" width="16" fill="currentColor" />
    <p class="fizz-flex-item">
      <strong>{salesRep.name}</strong><br />
      {#if salesRep.contact_email}
        <span class="fizz-text-subdued">{salesRep.contact_email}</span>
      {/if}
      {#if salesRep.contact_phone}
        <PhoneInput
          value={salesRep.contact_phone}
          extraClasses={"fizz-text-subdued"}
          placeholder="No Phone Number"
          viewOnly={true}
          id="phone"
        />
      {/if}
    </p>
    <div class="fizz-align-self-center" on:click={() => removeSalesRep(salesRep)}>
      <Icon
        extraClassNames="fizz-align-self-center cursor-pointer"
        type="Close"
        height="12"
        width="12"
        fill="#848484"
      />
    </div>
  </div>
{/if}
